import { render, staticRenderFns } from "./AutoSuggestSchool.vue?vue&type=template&id=17bf2e05&"
import script from "./AutoSuggestSchool.vue?vue&type=script&lang=js&"
export * from "./AutoSuggestSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports